module.exports = __webpack_public_path__ + "img/4.73f34cb6.jpg";